import styled from "styled-components";

export const SlickCardContainer = styled.div`
height: 250px;
// border: 1px solid white;
background-image:url(${props=> props.backgroundUrl});
background-size: cover;
width:90% !important;
margin-left:10px;
border-radius:15px;

`